import _ from "lodash/fp";
import React from "react";
import {Button, Glyphicon, Modal} from "react-bootstrap";
import {connect} from "react-redux";
import {deactivateSigntask} from "../../stores/signtasks/deactivateSigntask";
import { withTranslation, Trans } from 'react-i18next';

export default withTranslation()(connect(
  (state, props) => ({
    data: (state.signtasks.data ?? {})[props.signtask.id]
  }),
  dispatch => ({
    deactivateSigntask: _.compose(dispatch, deactivateSigntask)
  })
)(class extends React.Component {
  state = {
    showModal: false
  };
  
  deactivateSigntask = () => this.props.deactivateSigntask(this.props.signtask.id, this.props.deactivate || false, this.props.archive || false);

  showModal = () => this.setState({showModal: true});
  dismissModal = () => this.setState({showModal: false});

  render = () => {
    const { t } = this.props;
    const icon = this.props.deactivate ? "trash" : "folder-close";
    return(<React.Fragment>
      {this.props.deactivate && (<div>Status: {this.props.signtask.status}</div>)}
      {(this.props.data?.status ?? this.props.signtask.status) !== "Inaktiv" ?
        <Button bsStyle="danger" bsSize="xsmall" style={{margin: "0 .5rem"}} onClick={this.showModal}>
          <Glyphicon glyph={icon} /> {(this.props.deactivate) ? t("sign_task_deactivate") : t("list_signtask_archive_heading")}
        </Button> : null}

      <Modal show={this.state.showModal} onHide={this.dismissModal}>
        <Modal.Body>
        <Trans i18nKey="sign_task_deactivate_warning">
          Are you sure you want to disable this signing task?<br />Note that the event cannot be reversed.
        </Trans>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.dismissModal}>{t("sign_task_deactivate_no")}</Button>
          <Button onClick={() => {this.deactivateSigntask(); this.dismissModal()}} bsStyle="primary">{t("sign_task_deactivate_yes")}</Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>);
  }
}));